import FloodFill from './FloodFill'
import {
    isSameColor,
    setColorAtPixel,
    getColorAtPixel,
    colorToRGBA,
    hex2RGBA,
    ColorRGBA,
} from './util/colorUtils'

export default FloodFill
export {
    isSameColor,
    setColorAtPixel,
    getColorAtPixel,
    colorToRGBA,
    hex2RGBA,
    ColorRGBA,
}
